<template>
  <div class="mobile_navigate">
    <!-- 顶部导航栏 -->
    <div class="mobile-header">
      <router-link to="/home" class="brand" @click.native="closeMenu">
        <el-image :src="logo" fit="contain" class="logo">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </router-link>

      <button type="button" class="menu-btn" :aria-expanded="selectMore ? 'true' : 'false'" aria-label="Toggle navigation menu" @click="toggleMenu">
        <i :class="selectMore ? 'el-icon-close' : 'el-icon-menu'"></i>
      </button>
    </div>

    <!-- 遮罩 -->
    <transition name="fade">
      <div v-show="selectMore" class="mobile-mask" @click="closeMenu"></div>
    </transition>

    <!-- 菜单抽屉 -->
    <transition name="fade-slide">
      <div v-show="selectMore" class="mobile-drawer">
        <div class="drawer-title">
          <span>Menu</span>
          <span class="drawer-subtitle">AiLife Diagnostics</span>
        </div>

        <!-- 手机端搜索框 -->
        <div class="mobile-search-wrap">
          <search class="mobile-search" />
        </div>

        <el-menu :default-active="activeIndex" class="mobile-menu" unique-opened @select="handleSelect">
          <el-menu-item index="/home">
            <i class="el-icon-house"></i>
            <span slot="title">Home</span>
          </el-menu-item>

          <!-- Test Menu -->
          <el-submenu index="/test-menu">
            <template slot="title">
              <i class="el-icon-document"></i>
              <span>Test Menu</span>
            </template>

            <el-menu-item index="/test/WholeGenomeSequencingProbandOnly">
              Whole Genome Sequencing
            </el-menu-item>

            <el-menu-item index="/test/WholeExomeSequencingProbandOnly">
              Whole Exome Sequencing
            </el-menu-item>

            <!-- Clinical Specialties -->
            <el-submenu index="/test/clinical">
              <template slot="title">Clinical Specialties</template>

              <el-menu-item index="/test/category/audiology">
                Audiology
              </el-menu-item>

              <el-menu-item index="/test/category/cardiology">
                Cardiology
              </el-menu-item>

              <el-menu-item index="/test/category/connective-tissue-and-skin">
                Connective Tissue and Skin
              </el-menu-item>

              <el-menu-item index="/test/category/endocrinology">
                Endocrinology
              </el-menu-item>

              <el-menu-item index="/test/category/gastroenterology">
                Gastroenterology
              </el-menu-item>

              <el-menu-item index="/test/category/genome-wide-cnv-analysis">
                Genome-Wide CNV Analysis
              </el-menu-item>

              <el-menu-item index="/test/category/healthy-screening">
                Healthy Screening
              </el-menu-item>

              <el-menu-item index="/test/category/hematology">
                Hematology
              </el-menu-item>

              <el-menu-item index="/test/category/immunology">
                Immunology
              </el-menu-item>

              <el-menu-item index="/test/category/intellectual-disability">
                Intellectual Disability
              </el-menu-item>

              <el-menu-item index="/test/category/metabolic">
                Metabolic
              </el-menu-item>

              <el-menu-item index="/test/category/mitochondrial-genome-sequencing">
                Mitochondrial Genome Sequencing
              </el-menu-item>

              <el-menu-item index="/test/category/nephrology">
                Nephrology
              </el-menu-item>

              <el-menu-item index="/test/category/neurology">
                Neurology
              </el-menu-item>

              <el-menu-item index="/test/category/oncology">
                Oncology
              </el-menu-item>

              <el-menu-item index="/test/category/ophthalmology">
                Ophthalmology
              </el-menu-item>

              <el-menu-item index="/test/category/overgrowth-disorders">
                Overgrowth Disorders
              </el-menu-item>

              <el-menu-item index="/test/category/pharmacogenomics">
                Pharmacogenomics
              </el-menu-item>

              <el-menu-item index="/test/category/pulmonology">
                Pulmonology
              </el-menu-item>

              <el-menu-item index="/test/category/repeat-expansion-disorders">
                Repeat Expansion Disorders
              </el-menu-item>

              <el-menu-item index="/test/category/skeletal-and-dental">
                Skeletal and Dental
              </el-menu-item>
            </el-submenu>
          </el-submenu>

          <!-- How To Order -->
          <el-submenu index="/order">
            <template slot="title">
              <i class="el-icon-s-order"></i>
              <span>How To Order</span>
            </template>

            <el-menu-item index="/order/testing">
              How To Order Testing
            </el-menu-item>

            <el-menu-item index="/order/specimen">
              Specimen Requirements
            </el-menu-item>

            <el-menu-item index="/order/billing">
              Billing &amp; Insurance
            </el-menu-item>

            <el-menu-item index="/order/policies">
              Lab Policies
            </el-menu-item>

            <el-menu-item index="/order/forms">
              Forms
            </el-menu-item>
          </el-submenu>

          <!-- Resources -->
          <el-submenu index="/resources">
            <template slot="title">
              <i class="el-icon-collection"></i>
              <span>Resources</span>
            </template>

            <el-menu-item index="/clinical-case-examples">
              Clinical Case Examples
            </el-menu-item>

            <el-menu-item index="/products/RequestGeneticistConsultation">
              Request Geneticist Consultation
            </el-menu-item>

            <el-menu-item index="/products/VariantInterpretationService">
              Variant Interpretation Service
            </el-menu-item>

            <el-menu-item index="/products/Brochures">
              Product Brochures
            </el-menu-item>

            <el-menu-item index="/products/UnderstandingResults">
              Understanding Results
            </el-menu-item>
          </el-submenu>

          <!-- Industry and Research Services -->
          <el-submenu index="/Services">
            <template slot="title">
              <i class="el-icon-office-building"></i>
              <span>Industry and Research Services</span>
            </template>

            <el-menu-item index="/Services/BioPharmaPartnerships">
              BioPharma Partnerships
            </el-menu-item>

            <el-menu-item index="/Services/AilisNGS">
              AilisNGS<sup class="reg-mark">®</sup>
            </el-menu-item>
          </el-submenu>

          <!-- Portal Login -->
          <el-menu-item index="__portal__" class="portal-item">
            <i class="el-icon-user"></i>
            <span slot="title">Portal Login</span>
          </el-menu-item>
        </el-menu>
      </div>
    </transition>
  </div>
</template>

<script>
import picture from "@/utils/img";
import search from "@/views/search";

export default {
  name: "MobileHeader",

  components: {
    search,
  },

  data() {
    return {
      logo: picture.logo(),
      selectMore: false,
      activeIndex: this.getActiveIndex(this.$route.path),
    };
  },

  watch: {
    $route: {
      handler(val) {
        this.activeIndex = this.getActiveIndex(val.path);
        this.closeMenu();
      },
      immediate: true,
    },
  },

  beforeDestroy() {
    this.unlockBody();
  },

  methods: {
    toggleMenu() {
      this.selectMore = !this.selectMore;
      this.setBodyLock(this.selectMore);
    },

    closeMenu() {
      this.selectMore = false;
      this.unlockBody();
    },

    handleSelect(index) {
      if (!index) return;

      if (index === "__portal__") {
        window.open("https://report.ailifeus.com", "_blank");
        this.closeMenu();
        return;
      }

      if (index !== this.$route.path) {
        this.$router.push({ path: index }).catch((err) => {
          if (err && err.name !== "NavigationDuplicated") {
            console.error(err);
          }
        });
      }

      this.closeMenu();
    },

    getActiveIndex(path) {
      return path || "/home";
    },

    setBodyLock(lock) {
      if (typeof document !== "undefined") {
        document.body.style.overflow = lock ? "hidden" : "";
      }
    },

    unlockBody() {
      if (typeof document !== "undefined") {
        document.body.style.overflow = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile_navigate {
  width: 100%;
  height: 70px;
  background: #ffffff;
  box-shadow: 0 4px 18px rgba(18, 48, 92, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 12000;

  .mobile-header {
    height: 70px;
    padding: 0 16px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .brand {
    display: flex;
    align-items: center;
    text-decoration: none;
  }

  .logo {
    width: 148px;
    height: 54px;
    display: block;
  }

  .menu-btn {
    width: 42px;
    height: 42px;
    border: none;
    outline: none;
    border-radius: 12px;
    background: #eef5ff;
    color: #1a73e8;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;

    i {
      font-size: 24px;
      font-weight: 700;
    }

    &:active {
      transform: scale(0.96);
      background: #dcecff;
    }
  }

  .mobile-mask {
    position: fixed;
    top: 70px;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(15, 23, 42, 0.38);
    z-index: 12001;
  }

  .mobile-drawer {
    position: fixed;
    top: 70px;
    left: 0;
    right: 0;
    max-height: calc(100vh - 70px);
    overflow-y: auto;
    overflow-x: hidden;
    background: #f6f8fc;
    padding: 14px 14px 22px;
    box-sizing: border-box;
    z-index: 12002;
    box-shadow: 0 14px 28px rgba(15, 23, 42, 0.12);

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c8d6ea;
      border-radius: 6px;
    }
  }

  .drawer-title {
    background: linear-gradient(135deg, #1a73e8, #2b63b6);
    color: #ffffff;
    border-radius: 16px;
    padding: 14px 16px;
    margin-bottom: 12px;
    display: flex;
    flex-direction: column;
    gap: 3px;
    box-shadow: 0 8px 18px rgba(26, 115, 232, 0.18);

    span:first-child {
      font-size: 18px;
      font-weight: 700;
      line-height: 1.2;
    }

    .drawer-subtitle {
      font-size: 12px;
      opacity: 0.86;
    }
  }

  .mobile-search-wrap {
    background: #ffffff;
    border-radius: 14px;
    padding: 10px;
    margin-bottom: 12px;
    box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);
    position: relative;
    z-index: 12003;
    overflow: visible;
  }

  .mobile-search {
    display: block;
    width: 100%;
  }

  .mobile-menu {
    border-right: none;
    background: transparent;
  }

  .reg-mark {
    font-size: 0.6em;
    position: relative;
    top: -0.55em;
    margin-left: 1px;
  }
}

/* Element UI 菜单样式 */
.mobile_navigate {
  ::v-deep .el-menu {
    border-right: none !important;
    background: transparent !important;
  }

  ::v-deep .el-menu-item,
  ::v-deep .el-submenu__title {
    min-height: 50px !important;
    height: auto !important;
    line-height: 20px !important;
    padding-top: 14px !important;
    padding-bottom: 14px !important;
    margin: 7px 0;
    border-radius: 14px;
    color: #22314d !important;
    background: #ffffff !important;
    box-shadow: 0 3px 12px rgba(15, 23, 42, 0.055);
    font-size: 15px;
    font-weight: 600;
    white-space: normal;
    display: flex;
    align-items: center;
    box-sizing: border-box;
  }

  ::v-deep .el-menu-item:hover,
  ::v-deep .el-submenu__title:hover {
    background: #eef5ff !important;
    color: #1a73e8 !important;
  }

  ::v-deep .el-menu-item.is-active {
    color: #1a73e8 !important;
    background: #eef5ff !important;
    border: 1px solid rgba(26, 115, 232, 0.16);
  }

  ::v-deep .el-submenu__icon-arrow {
    color: #8da2c0;
    right: 16px;
    font-weight: 700;
  }

  ::v-deep .el-menu-item i,
  ::v-deep .el-submenu__title i {
    color: #1a73e8;
    margin-right: 8px;
    font-size: 18px;
  }

  ::v-deep .el-submenu .el-menu {
    background: transparent !important;
    padding-left: 10px;
    box-sizing: border-box;
  }

  ::v-deep .el-submenu .el-menu-item {
    min-height: 46px !important;
    padding-left: 34px !important;
    font-size: 14px;
    font-weight: 500;
    background: #ffffff !important;
    border: 1px solid #edf1f8;
    box-shadow: none;
  }

  ::v-deep .el-submenu .el-submenu .el-menu-item {
    padding-left: 42px !important;
    color: #34435e !important;
  }

  ::v-deep .portal-item {
    margin-top: 12px;
    background: linear-gradient(135deg, #1a73e8, #2b63b6) !important;
    color: #ffffff !important;
    justify-content: center;
    font-weight: 700;
    box-shadow: 0 8px 18px rgba(26, 115, 232, 0.22);

    i {
      color: #ffffff !important;
    }

    &:hover {
      color: #ffffff !important;
      background: linear-gradient(135deg, #1765cc, #255aa5) !important;
    }
  }
}

/* 动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.22s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.25s ease;
}

.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>

<!-- 这一段一定不要加 scoped，因为 el-popover 默认挂在 body 上 -->
<style lang="scss">
@media screen and (max-width: 768px) {
  .site-search-popper {
    width: calc(100vw - 28px) !important;
    max-width: calc(100vw - 28px) !important;
    min-width: 0 !important;
    left: 14px !important;
    right: 14px !important;
    box-sizing: border-box !important;
    border-radius: 14px !important;
    padding: 0 !important;
    overflow: hidden !important;
    z-index: 13000 !important;
    transform: none !important;
  }

  .site-search-popper[x-placement^="bottom"] {
    margin-top: 8px !important;
  }

  .site-search-popper .popper__arrow {
    display: none !important;
  }

  .site-search-popper .search-result-box {
    width: 100% !important;
    max-width: 100% !important;
    max-height: 55vh !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    box-sizing: border-box !important;
    background: #ffffff !important;
  }

  .site-search-popper .search-result-box > div {
    width: 100% !important;
    max-width: 100% !important;
    white-space: normal !important;
    word-break: break-word !important;
    overflow-wrap: break-word !important;
    line-height: 20px !important;
    padding: 12px 14px !important;
    box-sizing: border-box !important;
    color: #0f172a !important;
    font-size: 14px !important;
  }

  .site-search-popper .search-result-box > div:hover {
    background: #eef5ff !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/header/header.vue